import { notifications } from '@mantine/notifications';
import { IconAlertCircle, IconCircleCheck, IconInfoCircle } from '@tabler/icons-react';

type Notice = { title: string; message?: string };
type NoticeKind = 'success' | 'error' | 'info';

const icons = {
  success: IconCircleCheck,
  error: IconAlertCircle,
  info: IconInfoCircle,
};

const show = (kind: NoticeKind, { title, message }: Notice) => {
  const Icon = icons[kind];
  return notifications.show({
    title,
    message,
    variant: kind,
    color: `var(--color-notice-${kind})`,
    icon: <Icon size={22} stroke={2.2} aria-hidden="true" />,
    autoClose: kind === 'error' ? 7000 : 5000,
  });
};

export const notify = {
  success: (notice: Notice) => show('success', notice),
  error: (notice: Notice) => show('error', notice),
  info: (notice: Notice) => show('info', notice),
};
